import { COLORS } from '@constants/colors';

export const useStyles = () => ({
  dialogPaper: {
    bgcolor: COLORS.NEW_BLACK,
    color: COLORS.WHITE,
    border: `1px solid ${COLORS.WHITE_1}`,
    borderRadius: 1,
    boxShadow: '0 24px 80px rgba(0, 0, 0, 0.55)',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    pr: 1,
    color: COLORS.WHITE,
  },
  closeButton: {
    color: COLORS.WHITE,
  },
  dialogContent: {
    display: 'grid',
    gap: 2,
    pt: 1,
  },
  successContent: {
    display: 'grid',
    alignItems: 'center',
    minHeight: 140,
  },
  successAlert: {
    alignItems: 'center',
    '& .MuiAlert-message': {
      overflowWrap: 'anywhere',
    },
  },
  field: {
    '& .MuiInputLabel-root': { color: COLORS.WHITE_6 },
    '& .MuiInputLabel-root.Mui-focused': { color: COLORS.WHITE },
    '& .MuiInputBase-root': {
      color: COLORS.WHITE,
      backgroundColor: COLORS.WHITE_1,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.WHITE_6,
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.WHITE,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: COLORS.MYTAVERSE_BLUE,
    },
    '& .MuiSvgIcon-root': { color: COLORS.WHITE },
    '& textarea::placeholder': { color: COLORS.WHITE_6, opacity: 1 },
  },
  menuPaper: {
    bgcolor: COLORS.NEW_BLACK,
    color: COLORS.WHITE,
    border: `1px solid ${COLORS.WHITE_1}`,
    '& .MuiMenuItem-root:hover': {
      backgroundColor: COLORS.WHITE_1,
    },
    '& .Mui-selected': {
      backgroundColor: COLORS.WHITE_1,
    },
    '& .Mui-selected:hover': {
      backgroundColor: COLORS.WHITE_1,
    },
  },
  legend: {
    fontWeight: 600,
    mb: 0.5,
    color: COLORS.WHITE,
  },
  symptomGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  },
  checkbox: {
    color: COLORS.WHITE_6,
    '&.Mui-checked': { color: COLORS.MYTAVERSE_BLUE },
  },
  checkboxLabel: {
    color: COLORS.WHITE,
    '.MuiFormControlLabel-label': { fontSize: 14 },
  },
  attachButton: {
    color: COLORS.WHITE,
    borderColor: COLORS.WHITE_6,
    '&:hover': {
      borderColor: COLORS.WHITE,
      backgroundColor: COLORS.WHITE_1,
    },
  },
  attachmentWarning: {
    mt: 1,
  },
  attachmentList: {
    display: 'grid',
    gap: 0.75,
    mt: 1,
  },
  attachmentItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
  },
  iconButton: {
    color: COLORS.WHITE,
  },
  actions: {
    px: 3,
    pb: 2,
  },
  cancelButton: {
    color: COLORS.WHITE,
  },
  submitButton: {
    backgroundColor: COLORS.MYTAVERSE_BLUE,
    color: COLORS.WHITE,
    '&:hover': { backgroundColor: COLORS.CTA },
  },
});
